<button
  class="notification-trigger"
  mat-icon-button
  type="button"
  [matMenuTriggerFor]="notificationsMenu"
  [matBadge]="unreadNotificationsCount"
  [matBadgeHidden]="unreadNotificationsCount === 0"
  matTooltip="Notificaciones"
  aria-label="Abrir notificaciones"
>
  <mat-icon>notifications</mat-icon>
</button>

<mat-menu #notificationsMenu="matMenu" class="notifications-menu">
  <div class="notifications-panel">
    <header class="notifications-header">
      <div class="notifications-header__copy">
        <span class="notifications-header__eyebrow">Centro de actividad</span>
        <div class="notifications-header__title-row">
          <strong>Notificaciones</strong>
          <span
            *ngIf="unreadNotificationsCount > 0"
            class="notifications-header__count"
          >
            {{ unreadNotificationsCount }} sin leer
          </span>
        </div>
      </div>
      <gd-button
        *ngIf="unreadNotificationsCount > 0"
        label="Marcar todas"
        variant="basic"
        colorType="secondary"
        (buttonClick)="markAllAsRead()"
      ></gd-button>
    </header>

    <div
      *ngIf="notifications.length; else noNotifications"
      class="notifications-list"
      role="list"
    >
      <article
        class="notification-item"
        [class.notification-item--unread]="!notif.read"
        *ngFor="let notif of notifications.slice(0, 5)"
        role="listitem"
      >
        <span class="notification-item__icon" aria-hidden="true">
          <mat-icon>{{ getPresentation(notif).icon }}</mat-icon>
        </span>

        <div class="notification-content">
          <div class="notification-title-row">
            <strong>{{ getPresentation(notif).title }}</strong>
            <span *ngIf="!notif.read" class="unread-indicator">
              <span class="visually-hidden">Sin leer</span>
            </span>
          </div>

          <p class="notification-message">
            {{ getPresentation(notif).message }}
          </p>

          <time class="notification-date" [attr.datetime]="notif.createdAt">
            {{ notif.createdAt | date: "mediumDate" }}
          </time>

          <div class="notification-actions-row">
            <gd-button
              *ngIf="canNavigate(notif)"
              label="Ver detalle"
              iconName="arrow_forward"
              variant="basic"
              colorType="secondary"
              (buttonClick)="navigateToAction(notif)"
            ></gd-button>
            <gd-button
              *ngIf="!notif.read"
              label="Marcar como leída"
              iconName="done"
              variant="basic"
              colorType="secondary"
              (buttonClick)="markAsRead(notif)"
            ></gd-button>
          </div>
        </div>
      </article>
    </div>

    <ng-template #noNotifications>
      <div class="no-notifications-container">
        <span class="no-notifications-container__icon" aria-hidden="true">
          <mat-icon>notifications_none</mat-icon>
        </span>
        <strong>Estás al día</strong>
        <p>No hay notificaciones pendientes.</p>
      </div>
    </ng-template>

    <footer class="notifications-footer">
      <gd-button
        label="Ver todas las notificaciones"
        iconName="arrow_forward"
        variant="basic"
        colorType="secondary"
        classes="w-100"
        (buttonClick)="navigateToNotifications()"
      ></gd-button>
    </footer>
  </div>
</mat-menu>
